{
  "abbreviations": {
    "fs": "FS"
  },
  "degrees": {
    "11": "Diplom",
    "38": "LA Bachelor",
    "47": "LA Bachelor",
    "64": "LA Master",
    "66": "LA Master",
    "82": "Bachelor",
    "88": "Master",
    "97": "Zeitstudium",
    "ISL": "ISL-Test",
    "TEST": "ISL-Test"
  },
  "errors": {
    "invalidMail": "Die angegebene E-Mail-Adresse ist ungültig",
    "invalidPasswordComplexity": "Das Passwort sollte mindestens eine Nummer sowie einen Groß- und einen Kleinbuchstaben enthalten und 6 Zeichgen lang sein.",
    "nonKitOnly": "Eine Registrierung mit KIT-Adressen ist nicht möglich. KIT-Angehörige sollten die KIT-Anmeldung nutzen.",
    "passwordsDoNotMatch": "Die angegebenen Passwörter stimmen nicht überein"
  },
  "labels": {
    "add": "Hinzufügen",
    "all": "Alle",
    "apply": "Anwenden",
    "cancel": "Abbrechen",
    "changes": "Neuerungen",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "contact": "Kontakt",
    "create": "Anlegen",
    "discard": "Verwerfen",
    "discardchanges": "Änderungen verwerfen",
    "documentation": "Dokumentation",
    "edit": "Bearbeiten",
    "home": "Startseite",
    "optimizecontinue": "Verteilung fortsetzen",
    "optimizenew": "Neue Verteilung",
    "pleaseselect": "Bitte auswählen",
    "publish": "Veröffentlichen",
    "publishchanges": "Änderungen veröffentlichen",
    "save": "Speichern",
    "search": "Suchen",
    "sendmessage": "Nachricht senden",
    "settings": "Einstellungen",
    "signin": "Anmelden",
    "signout": "Abmelden",
    "signup": "Anmelden",
    "switchlanguage": "Switch to English",
    "yourchoice": "Ihre Auswahl"
  },
  "notifications": {
    "success": "Die Änderungen wurden erfolgreich durchgeführt."
  },
  "terms": {
    "close": "Schließen",
    "display": "Darstellung",
    "externaluser": "Externer Nutzer",
    "externalusers": "Externe Nutzer",
    "kitmember": "KIT-Angehörige/r",
    "language": "Sprache",
    "login": "Anmelden",
    "logout": "Abmelden",
    "no": "Nein",
    "none_female": "keine",
    "none_male": "keiner",
    "noresults": "Keine Ergebnisse",
    "of": "von",
    "register": "Registrieren",
    "requiredField": "Pflichtangabe",
    "term": "Semester",
    "unlimited": "unbegrenzt",
    "yes": "Ja"
  },
  "time": {
    "ended": "beendet",
    "in": "beginnt in {time}",
    "left": "noch {time}"
  }
}
